module.exports = __webpack_public_path__ + "media/common/images/dashboard/important-documents-illustration-big-e16ceb8e249c1bb86361290ab12edc01.svg";